<template>
  <div>
    <div class="head">
      <!-- Info Div -->
      <span><p>Current location: </p><p></p></span>
      <span>|</span>
      <span><p>Last Fill Time:</p><p>{{lastFilledTime}}</p></span>
      <span>|</span>
      <span><p>Current:</p><p></p>{{current}}</span>
    </div>
    <div  v-if="mapData !== null && mapData.length > 0">
      <div>
        <!-- Map div -->
        <GmapMap
          :center="mapData[mapData.length-1]['path'][mapData[mapData.length-1]['path'].length -1]"
          :zoom="16"
          map-type-id="hybrid"
          style="width: 50vw; height: 50vh"
        >
          <GmapPolyline
            :draggable="false"
            :editable="false"
            :clickable="true"
            @click="showActivityCard(data)"
            @mouseover="showHover(data)"
            @mouseleave="hideHover()"
            v-for="data in mapData"
            :key="data.starttime"
            :options="{ geodesic: true, strokeColor: color[data.type], path: data.path, strokeWeight: '10' }"
          ></GmapPolyline>
          <GmapMarker
            :position="mapData[mapData.length-1]['path'][mapData[mapData.length-1]['path'].length -1]"
            :clickable="false"
            :draggable="false"
            label='Tanker'
            :icon="require('../assets/tanker_rader.png')"
          />
        </GmapMap>
      </div>
      <div>
        <!-- legend div -->
      </div>
    </div>
    <div v-if="showActivity" class='activitycard'>
      <!-- Activity card div -->
      <div class="info">
        <span class="info-head"><h2>Check Location: </h2></span>
        <span><h2>{{getGpsAddress[this.addressOne]}}</h2></span>
      </div>
      <div class="info">
        <span class="info-head"><h2>Time Stayed at Location: </h2></span>
        <span><h2>{{activityCardDetails.starttime}} - {{activityCardDetails.endtime}}</h2></span>
      </div>
      <div class="info">
        <span class="info-head"><h2>Fuel volume on arrival: </h2></span>
        <span><h2>{{activityCardDetails.voa}}</h2></span>
      </div>
      <div class="info">
        <span class="info-head"><h2>Fuel volume on leaving: </h2></span>
        <span><h2>{{activityCardDetails.vol}}</h2></span>
      </div>
      <b-button @click="showActivity=false" class="close-button">Close</b-button>
    </div>
    <div v-if="showHoverCard" class="hover-card">
      <!-- Hover card div -->
      <div v-if="hoverCardDetails.type == 'moving'">
        <div><p>From {{getGpsAddress[this.addressOne]}}</p></div>
        <div><p>To {{getGpsAddress[this.addressTwo]}}</p></div>
      </div>
      <div v-else-if="hoverCardDetails.type == 'stop'">
        <div><p>At {{getGpsAddress[this.addressOne]}}</p></div>
        <div><p @click="showActivityCard(hoverCardDetails)" class="view">View details</p></div>
      </div>
    </div>
    <div v-else class="no-data">
      NO DATA FOR THIS DAY.
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Home',
  components: {
  },
  props: ['mapData', 'lastFilledTime', 'current'],
  data() {
    return {
      color: { stop: '#FF0000', moving: '#008000' },
      showActivity: false,
      activityCardDetails: {},
      showHoverCard: false,
      hoverCardDetails: {},
      addressOne: '',
      addressTwo: ''
    };
  },
  computed: {
    ...mapGetters('apps', ['getGpsAddress'])
  },
  methods: {
    ...mapActions('apps', ['storeGpsAddress']),
    showActivityCard(data) {
      if (data.type === 'stop') {
        this.addressOne = `${data.path[0].lat.toString()},${data.path[0].lng.toString()}`;
        this.getAddressFromCood(this.addressOne);
        this.activityCardDetails = data;
        this.showActivity = true;
      }
    },
    showHover(data) {
      this.addressOne = `${data.path[0].lat.toString()},${data.path[0].lng.toString()}`;
      this.getAddressFromCood(this.addressOne);
      if (data.type === 'moving') {
        this.addressTwo = `${data.path[data.path.length - 1].lat.toString()},${data.path[data.path.length - 1].lng.toString()}`;
        this.getAddressFromCood(this.addressTwo);
      }
      this.hoverCardDetails = data;
      this.showHoverCard = true;
    },
    hideHover() {
      this.showHoverCard = false;
    },
    getAddressFromCood(latlng) {
      if (latlng in this.getGpsAddress) {
        return false;
      }
      this.storeGpsAddress(latlng);
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  display: flex;
  margin-bottom: 20px;
  span {
    margin-left: 10px;
    font-weight: bold;
    display: flex;
    align-items: center;
    p {
      margin-right: 5px;
    }
  }
}
.activitycard {
  position: absolute;
  z-index: 100;
  top: 500px;
  background: white;
  padding: 10px;
  max-width: 300px;
}
.info {
  display: flex;
  font-size: 12px;
}
.info-head h2{
  font-weight: bold;
  margin-right: 5px;
}
.close-button {
  border: none;
  background: transparent;
  color: blue;
  font-size: 12px;
  text-decoration: underline;
  font-weight: bold;
  padding: 0;
  margin-top: 10px;
}
.hover-card {
  font-size: 13px;
  margin-top: 20px;
  p {
    font-weight: bold;
  }
  .view {
    cursor: pointer;
    color: blue;
  }
}
</style>

<style>
.vue-map-container {
  width: 100% !important;
}
</style>
